import React from "react";
import {
    FormikAutocompleteInput,
    FormikDateInput,
    FormikSelectInput,
    FormikTextInput,
    FormikTimeInput,
    FormikCheckboxGroup,
    FormikAutocompleteMultipleInput
} from "./FormikInputs";
import { FiltrosStyles } from "pages/Filtros.styles";
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded";
import { Button, HeaderButton } from "components";
export default function Filters({ formik, inputsRender }) {
    const styles = FiltrosStyles();
    return (
        <form className={styles.filtros} onSubmit={formik.handleSubmit}>
            {inputsRender.map((input, index) => (
                <div key={index} className={styles.inputContainer} style={input.width ? { "--filter-input-width": input.width } : undefined}>
                    {input.type.toLowerCase() === "text" && (
                        <FormikTextInput
                            data={{
                                [input.name]: {
                                    ...input,
                                },
                            }}
                            name={input.name}
                            formik={formik}
                            disabled={input.disabled}
                            className={styles.input}
                        />
                    )}
                    {input.type.toLowerCase() === "select" && (
                        <FormikSelectInput
                            data={{
                                [input.name]: {
                                    ...input,
                                },
                            }}
                            name={input.name}
                            formik={formik}
                            disabled={input.disabled}
                            options={input.options}
                            optionKey={input.firstOptionKey}
                            optionValue={input.firstOptionValue}
                            optionName={input.firstOptionName}
                            className={styles.input}
                        />
                    )}
                    {input.type.toLowerCase() === "date" && (
                        <FormikDateInput
                            // labelText={"Fecha Desde"}
                            // name="fechaDesde" v
                            type="date"
                            variant="standard"
                            data={{
                                [input.name]: {
                                    ...input,
                                },
                            }}
                            name={input.name}
                            formik={formik}
                            disabled={input.disabled}
                            className={styles.input}
                        />
                    )}
                    {input.type.toLowerCase() === "time" && (
                        <FormikTimeInput
                            data={{
                                [input.name]: {
                                    ...input,
                                },
                            }}
                            name={input.name}
                            formik={formik}
                            disabled={input.disabled}
                            className={styles.input}
                        />
                    )}
                    {input.type.toLowerCase() === "autocomplete" && (
                        <FormikAutocompleteInput
                            data={{ [input.name]: { ...input } }}
                            name={input.name}
                            formik={formik}
                            disabled={input.disabled}
                            options={input.options}
                            optionKey={input.firstOptionKey}
                            optionValue={input.firstOptionValue}
                            optionName={input.firstOptionName}
                            onChange={input.onChange}
                            className={styles.input}
                        />
                    )}
                    {input.type.toLowerCase() === "checkboxgroup" && (
                        <FormikCheckboxGroup
                            data={{
                                [input.name]: {
                                    ...input,
                                },
                            }}
                            name={input.name}
                            formik={formik}
                            disabled={input.disabled}
                            options={input.options}
                            optionKey={input.firstOptionKey}
                            optionValue={input.firstOptionValue}
                            optionName={input.firstOptionName}
                            className={styles.input}
                        />
                    )}
                    {input.type.toLowerCase() === "autocompletemultiple" && (
                        <FormikAutocompleteMultipleInput
                            data={{
                                [input.name]: {
                                    ...input,
                                },
                            }}
                            name={input.name}
                            formik={formik}
                            disabled={input.disabled}
                            options={input.options}
                            optionKey={input.firstOptionKey}
                            optionValue={input.firstOptionValue}
                            optionName={input.firstOptionName}
                            onChange={input.onChange}
                            className={styles.input}
                        />
                    )}
                </div>
            ))}
            <HeaderButton
                type="submit"
                className={styles.button}
                text={"Buscar"}
            >
                <FilterAltRoundedIcon />
            </HeaderButton>
        </form>
    );
}
